import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetSalaryGradesMutation } from '../apis';
import type { SalaryGradeQueryLinkerSchema } from '../schemas';

export function SalaryGradesSelect({ disabled, ...props }: FormAsyncComboboxProps<SalaryGradeQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: SalaryGradeQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/salary-grades/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetSalaryGradesMutation}
      disabled={disabled}
    />
  );
}
